<script setup lang="ts">
import { TextPrimaryMedium } from '@shared/ui/typography'
import { BtnText } from '@shared/ui/button'

defineOptions({
  name: 'FormBox',
})

withDefaults(defineProps<FormBoxProps>(), {
  required: true,
})

const emit = defineEmits<{
  'click:clear': []
}>()

interface FormBoxProps {
  title: string
  required?: boolean
}

const handleClick = (): void => {
  emit('click:clear')
}
</script>

<template>
  <div class="form-box">
    <div class="form-box__header">
      <TextPrimaryMedium>
        {{ title }}
        <span
          v-if="required"
          class="required-indicator"
        >*</span>
      </TextPrimaryMedium>
      <BtnText
        size="small"
        text="Clear"
        color="gray"
        @click="handleClick"
      />
    </div>
    <div class="form-box__content">
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./FormBox.scss" />
